import type { AuthenticatedUser } from "@authentication/domain/models/authenticated-user.model";
import type { UserSessionRepository } from "@authentication/domain/repositories/user-session.repository";
import { authenticationTypes } from "@authentication/root/authentication-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class AuthenticatedUserGetLoggedUseCase {
    constructor(
        @inject(authenticationTypes.repositories.UserSessionRepository)
        private readonly userSessionRepository: UserSessionRepository,
    ) {}
    execute(): AuthenticatedUser {
        return this.userSessionRepository.userSyncSafe;
    }
}
